import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class CheckIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8"><path fillRule="evenodd" d="M8.284 0l-4.59 4.73-2.127-1.837L0 4.693l2.985 2.571.858.736.784-.81L10 1.65z"/></svg>
        )
    }
}

export default withCssClassName(CheckIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/check-icon.js